/* eslint-disable */
import { Store } from 'vuex';
import { createVuexStore, useStore } from 'vuex-simple';

import { RootModule } from '@jtnews/core';

import { SocialsData } from '../domain';

import { UsersStore } from './+state/user.store';

let userFacade: UserFacade | null = null;

export enum ReachGoalsNames {
  View = 'viewAuthorisationForm',
  Click = 'clickAuthorisationForm',
  Auth = 'enterAuthorisationForm',
  Register = 'registerFromAuthorisationForm',
  Socials = 'enterViaSocial',
  Mail = 'enterViaEmail'
}

export enum ReachGoalFieldTypes {
  ViewModal = 'Просмотр',
  CloseModal = 'Закрыть',
  Register = 'Зарегистрироваться (кнопка)',
  NotMail = 'У меня нет почты',
  OpenAuth = 'Авторизация',
  EnterSocial = 'Вход через',
  AuthSubmit = 'Войти',
  OpenRegister = 'Регистрация',
  ChangeMail = 'Указать другую почту',
  SendAgain = 'Отправить повторно',
  Remember = 'Забыли пароль?',
  Back = 'Стрелочка возврата'
}

export class UserFacade {
  private _userStore: Store<UsersStore>;

  public get userStore(): UsersStore {
    return useStore<UsersStore>(this._userStore);
  }

  public get authLoginError(): string {
    return this.userStore.authLoginError;
  }

  public get authPasswordError(): string {
    return this.userStore.authPasswordError;
  }

  public get authApiErrorText(): string {
    return this.userStore.authApiErrorText;
  }

  public get isCaptchaApiError(): boolean {
    return this.userStore.isCaptchaApiError;
  }

  public get registerEmail(): string {
    return this.userStore.registerEmail;
  }

  public get registerPassword(): string {
    return this.userStore.registerPassword;
  }

  public get registerEmailError(): string {
    return this.userStore.registerEmailError;
  }

  public get registerPasswordError(): string {
    return this.userStore.registerPasswordError;
  }

  public get registerApiError(): string {
    return this.userStore.registerApiError;
  }

  public get confirmRegisterApiError(): string {
    return this.userStore.confirmRegisterApiError;
  }

  public get socialsList(): SocialsData[] {
    return this.userStore.socialsList;
  }

  public get socialsListWithoutRestricted(): SocialsData[] {
    return this.userStore.socialsListWithoutRestricted;
  }

  constructor(private _rootStore: RootModule) {
    this._initStore();
  }

  public async authorization(typeProfile: string): Promise<void> {
    await this.userStore.authorization(typeProfile);
  }

  public authThroughSocialsNN(link: string): void {
    this.userStore.authThroughSocialsNN(link);
  }

  public async register(): Promise<void> {
    void (await this.userStore.register());
  }

  public async confirmRegister(email: string): Promise<void> {
    void (await this.userStore.confirmNotifyEmail(email));
  }

  public setAuthLogin(login: string): void {
    this.userStore.setAuthLogin(login);
  }

  public setAuthPassword(password: string): void {
    this.userStore.setAuthPassword(password);
  }

  public setRegisterEmail(email: string): void {
    this.userStore.setRegisterEmail(email);
  }

  public setRegisterPassword(password: string): void {
    this.userStore.setRegisterPassword(password);
  }

  public resetAuthApiError(): void {
    this.userStore.resetAuthApiError();
  }

  private _initStore(): void {
    this._userStore = createVuexStore(
      new UsersStore(this._rootStore)
    ) as Store<UsersStore>;
  }
}

export const createUserFacade = (rootStore: RootModule): UserFacade => {
  if (userFacade === null) {
    userFacade = new UserFacade(rootStore);
  }

  return userFacade;
};
